<template>
	<div class="Home-div">
		<div class="Home-top">
			<Navbar></Navbar>
		</div>
	</div>
</template>

<script>
	import Navbar from "../components/Navbar.vue";
	export default {
		name: "AboutUs",
		components: {
			Navbar
		},
		data() {
		  return {
		  }
		}
	}
</script>

<style>
</style>